export default "__VITE_ASSET__BehlCdzd__"